export interface CatCrane {
  CraneId: number | null;
  Name: string;
  IsActive: boolean;
}

export const CAT_CRANE_INITIAL_VALUES: CatCrane = {
  CraneId: null,
  Name: "",
  IsActive: true,
};
